import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { investment } from "../investmentData"

const InvestmentDetail = () => {
    const { state } = useLocation()
    const navigate = useNavigate()
    const [investments, setInvestment] = useState({
        name: "",
        img: "",
        about: "",
        features: [],
        id: "",
    })

    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
        if(state && state.selectedPlan){
           const data = investment.find(i => (i.id === state.selectedPlan))
           console.log(data)
           setInvestment(data)
        }
    }, [investments, state])
 
    
    return(
        <div className="investment-detail">
       <button className="btn btn-back" onClick={() => {navigate(-1)}}><img src={`${process.env.PUBLIC_URL}/assets/icons/back.svg`} alt="back"/></button>
        <div className="investment-detail-container">
        <div className="investment-detail-text">
        <h1 className="investment-detail-title">{investments.name}</h1>
        <p>{investments.about}</p>
        <h2>FEATURES</h2>
        {investments.features.map(i => <div className="investment-feature-text">{i}</div>)}
        <button className="btn btn-primary shadow-none" onClick={() => navigate("/investment-form")}>Select Plan</button>
    </div>
    <div className="investment-detail-img">
        <img src={investments.image} alt="img"/>
    </div>
    </div>
        </div>
    )
}

export default InvestmentDetail